import { useEffect, useState } from "react"

export default function useCookieBot() {
  const [loading, setLoading] = useState(true)
  const [consent, setConsent] = useState(null)
  const [display, setDisplay] = useState(false)
  const [statistics, setStatistics] = useState(null)
  const [newConsent, setNewConsent] = useState(false)

  const onReady = () => {
    setLoading(false)
    setConsent(window?.Cookiebot.consent ?? null)
    setStatistics(window?.Cookiebot.consent?.statistics ?? false)
  }

  const onDisplay = () => {
    setDisplay(true)
  }

  useEffect(() => {
    window.addEventListener("CookiebotOnConsentReady", onReady)
    window.addEventListener("CookiebotOnDialogDisplay", onDisplay)
    return () => {
      window.removeEventListener("CookiebotOnConsentReady", onReady)
      window.removeEventListener("CookiebotOnDialogDisplay", onDisplay)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (statistics === null) {
      return
    }

    if (statistics && display) {
      setNewConsent(true)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statistics])

  return {
    loading,
    newConsent,
    statistics,
    consent
  }
}
